import type { Patient, PatientDTO, PatientSettings, PatientSettingsDTO } from "@akina/domain";
import { decodeHtmlTextFromString } from "@akina/utils";
import { mapDateFromApi, type Mapper } from "./";

export const patientMapper: Mapper<Patient, PatientDTO> = {
  toDomain: patientDto => ({
    patientId: patientDto.patient_id,
    firstName: decodeHtmlTextFromString(patientDto.first_name),
    lastName: decodeHtmlTextFromString(patientDto.last_name),
    profilePictureUrl: patientDto.profile_picture_url,
    treatmentIds: patientDto.treatment_ids,
    signedUpAt: mapDateFromApi(patientDto.signed_up_at),
    preferences: patientSettingsMapper.toDomain(patientDto.preferences),
    state: patientDto.state,
    streakActive: patientDto.streak_active,
  }),
  toDTO: patientDomain => ({
    patient_id: patientDomain.patientId,
    first_name: patientDomain.firstName,
    last_name: patientDomain.lastName,
    profile_picture_url: patientDomain.profilePictureUrl,
    treatment_ids: patientDomain.treatmentIds,
    signed_up_at: patientDomain.signedUpAt.toString(),
    preferences: patientSettingsMapper.toDTO(patientDomain.preferences),
    state: patientDomain.state,
    streak_active: patientDomain.streakActive,
  }),
};

export const patientSettingsMapper: Mapper<PatientSettings, PatientSettingsDTO> = {
  toDomain: patientSettingsDto => ({
    language: patientSettingsDto.language,
    coachSound: patientSettingsDto.coach_sound,
    musicSound: patientSettingsDto.music,
    repetitionSound: patientSettingsDto.repetition,
    notifications: {
      email: {
        sessionReminders: patientSettingsDto.notifications?.email?.session_reminders ?? false,
        sessionCompletions: patientSettingsDto.notifications?.email?.session_completions ?? false,
        therapistFeedback: patientSettingsDto.notifications?.email?.therapist_feedback ?? false,
        reminderNoActive: patientSettingsDto.notifications?.email?.reminder_no_active ?? false,
        phaseChange: patientSettingsDto.notifications?.email?.phase_change ?? false,
      },
    },
  }),
  toDTO: patientSettingsDomain => ({
    language: patientSettingsDomain.language,
    coach_sound: patientSettingsDomain.coachSound,
    music: patientSettingsDomain.musicSound,
    repetition: patientSettingsDomain.repetitionSound,
    notifications: {
      email: {
        session_reminders: patientSettingsDomain.notifications.email.sessionReminders,
        session_completions: patientSettingsDomain.notifications.email.sessionCompletions,
        therapist_feedback: patientSettingsDomain.notifications.email.therapistFeedback,
        reminder_no_active: patientSettingsDomain.notifications.email.reminderNoActive,
        phase_change: patientSettingsDomain.notifications.email.phaseChange,
      },
    },
  }),
};
